const step0Values = [
	"Road",
	"Gravel+%26+Cyclocross",
	"Triathlon+%26+TT",
	"MTB",
	"e-Bike",
];
const step1Values = [
	"141-145",
	"146-150",
	"151-155",
	"156-160",
	"161-165",
	"166-170",
	"171-175",
	"176-180",
	"181-185",
	"186-190",
	"191-195",
	"196-200",
	"201-205",
	"206-210",
];

const step1Filters = {
	"141-145": ["XXS / 43-46cm"],
	"146-150": ["XXS / 43-46cm"],
	"151-155": ["XS / 47-48cm"],
	"156-160": ["XS / 47-48cm"],
	"161-165": ["S / 49-51cm"],
	"166-170": ["S / 49-51cm", "M / 52-54cm"],
	"171-175": ["M / 52-54cm"],
	"176-180": ["M / 52-54cm", "L / 55-56cm"],
	"181-185": ["L / 55-56cm"],
	"186-190": ["L / 55-56cm", "XL / 57-59cm"],
	"191-195": ["XL / 57-59cm"],
	"196-200": ["XL / 57-59cm", "XXL / 60+cm"],
	"201-205": ["XXL / 60+cm"],
	"206-210": ["XXL / 60+cm"],
};

const step2Values = ["BUDGET FRIENDLY", "MID RANGE", "HIGH END"];
const step3Values = ["soon", "planning", "unknown"];
const step4Values = ["0", "1", "2+"];

const step0Container = document.getElementById("step-0");
const step1Container = document.getElementById("step-1");
const step2Container = document.getElementById("step-2");
const step3Container = document.getElementById("step-3");
const step4Container = document.getElementById("step-4");
const step5Container = document.getElementById("step-5");

const step0Title = document.getElementById("step-0-title");
const step1Title = document.getElementById("step-1-title");
const step2Title = document.getElementById("step-2-title");
const step3Title = document.getElementById("step-3-title");
const step4Title = document.getElementById("step-4-title");
const step5Title = document.getElementById("step-5-title");

const image0 = document.getElementById("image-0");
const image1 = document.getElementById("image-1");
const image2 = document.getElementById("image-2");
const image3 = document.getElementById("image-3");
const image4 = document.getElementById("image-4");
const image5 = document.getElementById("image-5");
const image6 = document.getElementById("image-6");

const flowContainer = document.getElementById("bf-flow-container");
const endContainer = document.getElementById("bf-end");

const continueButton = document.getElementById("bf-continue");
const backButton = document.getElementById("bf-back");
const submitButton = document.getElementById("bf-submit");
const resetButton = document.getElementById("bf-restart");

const stepSpan = document.getElementById("step-number");

let formData = {
	email: null,
	categories: [],
	height: null,
	price_range: null,
	time_to_buy: null,
	bike_owned: null,
};

const step0Items = document.querySelectorAll(".step-0-item");
step0Items.forEach((item) => {
	item.addEventListener("change", () => {
		let index = item.value;
		let value = step0Values[index];

		if (item.checked) {
			formData.categories.push(value);
		} else {
			let ix = formData.categories.findIndex((x) => x === value);
			formData.categories.splice(ix, 1);
		}

		if (formData.categories.length == 0) {
			continueButton.setAttribute("disabled", "");
		} else {
			continueButton.removeAttribute("disabled");
		}
	});
});

const step1Items = document.querySelectorAll(".step-1-item");
step1Items.forEach((item) => {
	item.addEventListener("change", () => {
		let index = item.value;
		let value = step1Values[index];

		if (item.checked) {
			formData.height = value;
		}
		if (!formData.height) {
			continueButton.setAttribute("disabled", "");
		} else {
			continueButton.removeAttribute("disabled");
		}
	});
});

const step2Items = document.querySelectorAll(".step-2-item");
step2Items.forEach((item) => {
	item.addEventListener("change", () => {
		let index = item.value;
		let value = step2Values[index];

		if (item.checked) {
			formData.price_range = value;
		}

		if (!formData.price_range) {
			continueButton.setAttribute("disabled", "");
		} else {
			continueButton.removeAttribute("disabled");
		}
	});
});

const step3Items = document.querySelectorAll(".step-3-item");
step3Items.forEach((item) => {
	item.addEventListener("change", () => {
		let index = item.value;
		let value = step3Values[index];

		if (item.checked) {
			formData.time_to_buy = value;
		}

		if (!formData.time_to_buy) {
			continueButton.setAttribute("disabled", "");
		} else {
			continueButton.removeAttribute("disabled");
		}
	});
});

const step4Items = document.querySelectorAll(".step-4-item");
step4Items.forEach((item) => {
	item.addEventListener("change", () => {
		let index = item.value;
		let value = step4Values[index];

		if (item.checked) {
			formData.bike_owned = value;
		}

		if (!formData.bike_owned) {
			continueButton.setAttribute("disabled", "");
		} else {
			continueButton.removeAttribute("disabled");
		}
	});
});

const mailInput = document.getElementById("mail-input");
mailInput.addEventListener("input", (e) => {
	formData.email = e.target.value;

	let valid = validateEmail(e.target.value);

	if (formData.email && formData.email != "" && valid) {
		submitButton.removeAttribute("disabled");
	} else {
		submitButton.setAttribute("disabled", "");
	}
});

// Button events
let step = 0;
continueButton.addEventListener("click", () => {
	changeStep(step + 1);
});

backButton.addEventListener("click", () => {
	changeStep(step - 1);
});

submitButton.addEventListener("click", () => {
	submitData();
});

function reset() {
	//endContainer.classList.add("hidden");
	//flowContainer.classList.remove("hidden");
	formData = {
		email: null,
		categories: [],
		height: null,
		price_range: null,
		time_to_buy: null,
		bike_owned: null,
	};

	step0Items.forEach((item) => {
		item.checked = false;
	});
	step1Items.forEach((item) => {
		item.checked = false;
	});
	step2Items.forEach((item) => {
		item.checked = false;
	});
	step3Items.forEach((item) => {
		item.checked = false;
	});
	step4Items.forEach((item) => {
		item.checked = false;
	});
	mailInput.value = "";

	//changeStep(0);
}

function changeStep(newStep) {
	if (newStep < 0 || newStep > 5) return;
	let oldStep = step;
	step = newStep;
	stepSpan.innerHTML = newStep + 1;
	switch (step) {
		case 0:
			backButton.classList.add("hidden");

			continueButton.classList.remove("hidden");
			submitButton.classList.add("hidden");

			step0Container.classList.remove("hidden");
			step0Title.classList.remove("hidden");

			step1Container.classList.add("hidden");
			step2Container.classList.add("hidden");

			step5Container.classList.add("hidden");
			step5Title.classList.add("hidden");

			image0.classList.remove("hidden");
			image1.classList.add("hidden");
			image6.classList.add("hidden");

			if (formData.categories.length == 0) {
				continueButton.setAttribute("disabled", "");
			} else {
				continueButton.removeAttribute("disabled");
			}
			break;
		case 1:
			backButton.classList.remove("hidden");

			step0Container.classList.add("hidden");
			step0Title.classList.add("hidden");

			step1Container.classList.remove("hidden");
			step1Title.classList.remove("hidden");

			step2Container.classList.add("hidden");
			step2Title.classList.add("hidden");

			image0.classList.add("hidden");
			image1.classList.remove("hidden");
			image2.classList.add("hidden");

			if (!formData.height) {
				continueButton.setAttribute("disabled", "");
			} else {
				continueButton.removeAttribute("disabled");
			}
			break;
		case 2:
			step1Container.classList.add("hidden");
			step1Title.classList.add("hidden");

			step2Container.classList.remove("hidden");
			step2Title.classList.remove("hidden");

			step3Container.classList.add("hidden");
			step3Title.classList.add("hidden");

			image1.classList.add("hidden");
			image2.classList.remove("hidden");
			image3.classList.add("hidden");

			if (!formData.price_range) {
				continueButton.setAttribute("disabled", "");
			} else {
				continueButton.removeAttribute("disabled");
			}
			break;
		case 3:
			step2Container.classList.add("hidden");
			step2Title.classList.add("hidden");

			step3Container.classList.remove("hidden");
			step3Title.classList.remove("hidden");

			step4Container.classList.add("hidden");
			step4Title.classList.add("hidden");

			image2.classList.add("hidden");
			image3.classList.remove("hidden");
			image4.classList.add("hidden");

			if (!formData.time_to_buy) {
				continueButton.setAttribute("disabled", "");
			} else {
				continueButton.removeAttribute("disabled");
			}
			break;
		case 4:
			step3Container.classList.add("hidden");
			step3Title.classList.add("hidden");

			step4Container.classList.remove("hidden");
			step4Title.classList.remove("hidden");

			step5Container.classList.add("hidden");
			step5Title.classList.add("hidden");

			image3.classList.add("hidden");
			image4.classList.remove("hidden");
			image5.classList.add("hidden");

			continueButton.classList.remove("hidden");
			submitButton.classList.add("hidden");

			if (!formData.bike_owned) {
				continueButton.setAttribute("disabled", "");
			} else {
				continueButton.removeAttribute("disabled");
			}
			break;
		case 5:
			step4Container.classList.add("hidden");
			step4Title.classList.add("hidden");

			step5Container.classList.remove("hidden");
			step5Title.classList.remove("hidden");

			image4.classList.add("hidden");
			image5.classList.remove("hidden");

			continueButton.classList.add("hidden");
			submitButton.classList.remove("hidden");

			if (!formData.email) {
				submitButton.setAttribute("disabled", "");
			} else {
				submitButton.removeAttribute("disabled");
			}
			break;
		default:
			break;
	}
}

function validateEmail(email) {
	return String(email)
		.toLowerCase()
		.match(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
}

async function submitData() {
	//
	// Send data
	//

	let url = "https://bike-room.com";
	if (bfBaseUrl != "/") {
		url += bfBaseUrl;
	}

	url += "/collections/buy-bikes-online?filter.v.availability=1&";

	for (const x of formData.categories) {
		url += `filter.p.product_type=${x}&`;
	}

	url += `filter.p.m.price.price_range=${formData.price_range}&`;

	let sf = step1Filters[formData.height];

	if (sf) {
		for (const x of sf) {
			url += `filter.v.option.size=${x}&`;
		}
	}

	url = url.slice(0, -1);

	formData.redirect_url = url;

	if (bfLocale) {
		formData.locale = bfLocale;
	}
	flowContainer.classList.add("hidden");
	endContainer.classList.remove("hidden");

	image5.classList.add("hidden");
	image6.classList.remove("hidden");

	const k = window.klaviyo || (window._learnq = window._learnq || []);
	k.push(["identify", { email: formData.email }]);
	k.push(["track", "bike_finder_result", formData]);

    window.location.href = formData.redirect_url;

	reset();

}
